export default "__VITE_ASSET__1c69ef16__"